import { createRouter, createWebHistory } from "vue-router";
// import App from "../App.vue";
import LoginHabb from "../components/LoginHabb.vue";
import RegistrationHabb from "../components/RegistrationHabb.vue";
import ProfileUser from "../components/ProfileUser.vue";

const routers = [
  // Временная заглушка для главной страницы: перекидываем в профиль.
  // (А охранник сам решит: пустить в профиль или выкинуть на логин)
  // { path: "/", redirect: "/profile" },
  { path: "/login", component: LoginHabb },
  { path: "/registration", component: RegistrationHabb },
  { path: "/profile", component: ProfileUser },
];

const router = createRouter({
  history: createWebHistory(),
  routes: routers,
});

// Защита маршрутов: проверяем авторизацию перед каждым переходом
router.beforeEach((to, from, next) => {
  // Проверяем, есть ли в браузере сохраненный токен
  const isAuthenticated = !!localStorage.getItem("token");

  // Массив путей, куда нельзя заходить авторизованному (логин и рега)
  const authRoutes = ["/login", "/registration"];

  // Массив путей, куда нельзя заходить БЕЗ авторизации (закрытые страницы)
  const protectedRoutes = ["/profile"];

  // Если пользователь уже вошел и пытается зайти на логин/регу
  if (isAuthenticated && authRoutes.includes(to.path)) {
    // Выкидываем его обратно в профиль (или на главную)
    next("/profile");
  } else if (!isAuthenticated && protectedRoutes.includes(to.path)) {
    // Если гость пытается зайти в профиль — выкидываем на логин
    next("/login");
  } else {
    // В противном случае пропускаем дальше
    next();
  }
});

export default router;
